import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  FaX,
  FaPenToSquare,
  FaRegTrashCan,
  FaCheck,
  FaPlus,
} from "react-icons/fa6";
import { FaExternalLinkAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import Navbar from "../../components/Navbar";
import Empleos from "../../components/carrusel/UserEmpleosDestacados";
import { API_programas, API_recursos } from "../../config/apiConfig";
import "./css/Empleo.css";

const Empleo = () => {
  const { role } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = useState(false);
  const [categoria, setCategoria] = useState("destacadas");

  // (**) Estados para gestión de recursos de empleo
  const [recursosEmpleo, setRecursosEmpleo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mostrarModalNuevo, setMostrarModalNuevo] = useState(false);
  const [nuevoRecurso, setNuevoRecurso] = useState({ nombre: "", url: "" });

  const [editId, setEditId] = useState(null);
  const [editValues, setEditValues] = useState({ nombre: "", url: "" });

  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  // (**) Cargar recursos de empleo al abrir el modal
  useEffect(() => {
    if (showModal) {
      fetchRecursosEmpleo();
    }
  }, [showModal]);



  // (**) Obtener recursos de empleo del endpoint
  const fetchRecursosEmpleo = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_recursos}?category=empleo`);
      const data = await res.json();
     
      const recursosEmpleo = data.map(({id,link,title}) => {
     
          return {
            id,
            nombreReal: title,
            url: link,
          };
        });
    
        
      setRecursosEmpleo(recursosEmpleo);
    } catch (error) {
      console.error("Error al cargar recursos de empleo:", error);
      toast.error("Error al cargar recursos de empleo");
    } finally {
      setLoading(false);
    }
  };


  // (**) Guardar nuevo recurso de empleo
  const handleGuardarRecurso = async () => {
    const { nombre, url } = nuevoRecurso;
    if (!nombre || !url) {
      toast.error("Nombre y URL son obligatorios");
      return;
    }

    try {

      const res = await fetch(API_recursos, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: nombre,
          link: url, 
          category: "empleo",
          isFeatured: false
        }),
      });

      if (!res.ok) throw new Error();

      const recursoEmpleo = await res.json();
   
      const recursoParseado = {
            id :recursoEmpleo.id,
            nombreReal: recursoEmpleo.title,
            url: recursoEmpleo.link,    
      };

      setRecursosEmpleo([...recursosEmpleo, recursoParseado]);
      setMostrarModalNuevo(false);
      setNuevoRecurso({ nombre: "", url: "" });
      toast.success("Recurso de empleo guardado");
    } catch (err) {
      console.error("Error al guardar el recurso:", err);
      toast.error("No se pudo guardar el recurso");
    }
  };

  // (**) Iniciar edición
  const startEdit = (recurso) => {
    setEditId(recurso.id);
    setEditValues({
      nombre: recurso.nombreReal, // Usar nombreReal parseado
      url: recurso.url, // Usar url parseada
    });
  };


  // (**) Guardar edición
  const guardarEdicion = async () => {
    const { nombre, url } = editValues;

    if (!nombre || !url) {
      toast.error("Nombre y URL son obligatorios");
      return;
    }

  
    // Enviar PUT
    try {
      const res = await fetch(`${API_recursos}/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body:  JSON.stringify({
          title: nombre,
          link: url, 
        })
      });
      if (!res.ok) throw new Error();

         // Actualizar tabla inmediatamente con datos parseados
    setRecursosEmpleo(
      recursosEmpleo.map((r) =>
        r.id === editId
          ? {
              ...r,
              nombreReal: nombre,
              url: url,
            }
          : r
      )
    );

      toast.success("Recurso actualizado");
    } catch (err) {
      console.error(err);
      toast.error("No se pudo actualizar el recurso");
     } finally {
    setEditId(null); // Siempre se ejecuta
  }
  };

  // (**) Cancelar edición
  const cancelarEdicion = () => setEditId(null);

  // (**) Borrar recurso
  const borrarRecurso = async () => {
    try {
      const res = await fetch(`${API_recursos}/${deleteId}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error();

      setRecursosEmpleo(recursosEmpleo.filter((r) => r.id !== deleteId));
      toast.success("Recurso eliminado");
    } catch (err) {
      console.error(err);
      toast.error("No se pudo eliminar el recurso");
    } finally {
      setDeleteId(null);
    }
  };

  return (
    <>
      <Navbar />

      <main className="main empleo-formacion tecnicos">
        {/* Botones crear ofertas y recursos */}
        {(role === "administrador" || role === "tecnico-1") && (
          <section className="botones-crear flex gap-10">
            <button
              className="boton-modal boton"
              onClick={() => setShowModal(true)}
            >
              Dónde buscar más ofertas de empleo
            </button>
            <Link to="/admin/nuevo-empleo" className="verde align-center">
              Dar de alta una oferta de empleo
            </Link>
          </section>
        )}

        {/* (**) Modal mejorado con CRUD */}
        {showModal && (
          <div className="historico-seguimiento">
            <div
              className="modal-content"
              style={{ maxWidth: "900px", width: "90vw" }}
            >
              <div
                className="modal-header mayusculas"
                style={{
                  background: "linear-gradient(135deg, #007932, #005925)",
                  color: "white",
                  padding: "20px",
                  borderRadius: "10px 10px 0 0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2
                  style={{ margin: 0, fontSize: "1.5rem", fontWeight: "600" }}
                >
                  🔍 Recursos para búsqueda de empleo
                </h2>
                <button
                  className="close-button"
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    border: "none",
                    padding: "8px",
                    borderRadius: "50%",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.3)")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.2)")
                  }
                >
                  <FaX />
                </button>
              </div>

              <div style={{ padding: "25px", background: "#f8fafc" }}>
                {/* (**) Botón para agregar nuevo recurso */}
                {(role === "administrador" || role === "tecnico-1") && (
                  <div style={{ marginBottom: "25px", textAlign: "center" }}>
                    <button
                      onClick={() => setMostrarModalNuevo(true)}
                      style={{
                        background: "linear-gradient(135deg, #007932, #005925)",
                        border: "none",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        color: "white",
                        fontWeight: "500",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        margin: "0 auto",
                        transition: "all 0.2s",
                        boxShadow: "0 2px 4px rgba(16, 185, 129, 0.3)",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.transform = "translateY(-1px)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.transform = "translateY(0)")
                      }
                    >
                      <FaPlus /> Agregar nuevo recurso
                    </button>
                  </div>
                )}

                {/* (**) Lista de recursos */}
                {loading ? (
                  <div style={{ textAlign: "center", padding: "40px" }}>
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        border: "4px solid #e5e7eb",
                        borderTop: "4px solid #007932",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        margin: "0 auto 15px",
                      }}
                    ></div>
                    <p style={{ color: "#6b7280" }}>Cargando recursos...</p>
                  </div>
                ) : (
                  <div
                    style={{
                      background: "white",
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    {recursosEmpleo.length > 0 ? (
                      <div className="shared-table-wrapper">
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr style={{ background: "#f1f5f9" }}>
                              <th
                                style={{
                                  padding: "15px",
                                  textAlign: "left",
                                  fontWeight: "600",
                                  color: "#374151",
                                  borderBottom: "2px solid #e5e7eb",
                                }}
                              >
                                📝 Nombre del recurso
                              </th>
                              <th
                                style={{
                                  padding: "15px",
                                  textAlign: "left",
                                  fontWeight: "600",
                                  color: "#374151",
                                  borderBottom: "2px solid #e5e7eb",
                                }}
                              >
                                🔗 Enlace
                              </th>
                              {(role === "administrador" ||
                                role === "tecnico-1") && (
                                <th
                                  style={{
                                    padding: "15px",
                                    textAlign: "center",
                                    fontWeight: "600",
                                    color: "#374151",
                                    borderBottom: "2px solid #e5e7eb",
                                    width: "120px",
                                  }}
                                >
                                  ⚙️ Acciones
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {recursosEmpleo.map((recurso, index) =>
                              editId === recurso.id ? (
                                // Modo edición
                                <tr
                                  key={recurso.id}
                                  style={{ background: "#fff7ed" }}
                                >
                                  <td
                                    style={{
                                      padding: "12px 15px",
                                      borderBottom: "1px solid #e5e7eb",
                                    }}
                                  >
                                    <input
                                      style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "2px solid #f59e0b",
                                        borderRadius: "6px",
                                        fontSize: "14px",
                                      }}
                                      value={editValues.nombre}
                                      onChange={(e) =>
                                        setEditValues({
                                          ...editValues,
                                          nombre: e.target.value,
                                        })
                                      }
                                      placeholder="Nombre del recurso"
                                    />
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px 15px",
                                      borderBottom: "1px solid #e5e7eb",
                                    }}
                                  >
                                    <input
                                      type="url"
                                      style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "2px solid #f59e0b",
                                        borderRadius: "6px",
                                        fontSize: "14px",
                                      }}
                                      value={editValues.url}
                                      onChange={(e) =>
                                        setEditValues({
                                          ...editValues,
                                          url: e.target.value,
                                        })
                                      }
                                      placeholder="https://ejemplo.com"
                                    />
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px 15px",
                                      borderBottom: "1px solid #e5e7eb",
                                      textAlign: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <button
                                        onClick={guardarEdicion}
                                        style={{
                                          background: "#007932",
                                          border: "none",
                                          padding: "8px",
                                          borderRadius: "4px",
                                          color: "white",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <FaCheck />
                                      </button>
                                      <button
                                        onClick={cancelarEdicion}
                                        style={{
                                          background: "#ef4444",
                                          border: "none",
                                          padding: "8px",
                                          borderRadius: "4px",
                                          color: "white",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <FaX />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                // Fila normal
                                <tr
                                  key={recurso.id}
                                  style={{
                                    background:
                                      index % 2 === 0 ? "white" : "#f8fafc",
                                    transition: "all 0.2s",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background =
                                      "#e0f2fe")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background =
                                      index % 2 === 0 ? "white" : "#f8fafc")
                                  }
                                >
                                  <td
                                    style={{
                                      padding: "15px",
                                      borderBottom: "1px solid #e5e7eb",
                                      fontWeight: "500",
                                      color: "#374151",
                                    }}
                                  >
                                    {recurso.nombreReal}
                                  </td>
                                  <td
                                    style={{
                                      padding: "15px",
                                      borderBottom: "1px solid #e5e7eb",
                                    }}
                                  >
                                    {recurso.url ? (
                                      <a
                                        href={recurso.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                          color: "#007932",
                                          textDecoration: "none",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          fontWeight: "500",
                                        }}
                                        onMouseOver={(e) =>
                                          (e.target.style.textDecoration =
                                            "underline")
                                        }
                                        onMouseOut={(e) =>
                                          (e.target.style.textDecoration =
                                            "none")
                                        }
                                      >
                                        <FaExternalLinkAlt size={12} />
                                        {recurso.url && recurso.url.length > 50
                                          ? `${recurso.url.substring(0, 47)}...`
                                          : recurso.url || ""}
                                      </a>
                                    ) : (
                                      <span
                                        style={{
                                          color: "#9ca3af",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        Sin URL configurada
                                      </span>
                                    )}
                                  </td>
                                  {(role === "administrador" ||
                                    role === "tecnico-1") && (
                                    <td
                                      style={{
                                        padding: "15px",
                                        borderBottom: "1px solid #e5e7eb",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          onClick={() => startEdit(recurso)}
                                          style={{
                                            background: "none",
                                            border: "none",
                                            padding: "6px",
                                            borderRadius: "4px",
                                            color: "#007932",
                                            cursor: "pointer",
                                            transition: "all 0.2s",
                                          }}
                                          onMouseOver={(e) =>
                                            (e.target.style.background =
                                              "#ecfdf5")
                                          }
                                          onMouseOut={(e) =>
                                            (e.target.style.background = "none")
                                          }
                                          title="Editar recurso"
                                        >
                                          <FaPenToSquare />
                                        </button>
                                        <button
                                          onClick={() => {
                                            setDeleteId(recurso.id);
                                            setDeleteName(
                                              recurso.nombreReal 
                                            );
                                          }}
                                          style={{
                                            background: "none",
                                            border: "none",
                                            padding: "6px",
                                            borderRadius: "4px",
                                            color: "#ef4444",
                                            cursor: "pointer",
                                            transition: "all 0.2s",
                                          }}
                                          onMouseOver={(e) =>
                                            (e.target.style.background =
                                              "#fef2f2")
                                          }
                                          onMouseOut={(e) =>
                                            (e.target.style.background = "none")
                                          }
                                          title="Eliminar recurso"
                                        >
                                          <FaRegTrashCan />
                                        </button>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "60px 20px",
                          color: "#6b7280",
                        }}
                      >
                        <div style={{ fontSize: "48px", marginBottom: "15px" }}>
                          📋
                        </div>
                        <p
                          style={{
                            fontSize: "18px",
                            fontWeight: "500",
                            marginBottom: "8px",
                          }}
                        >
                          No hay recursos configurados
                        </p>
                        <p style={{ fontSize: "14px" }}>
                          {role === "administrador" || role === "tecnico-1"
                            ? "Agrega el primer recurso haciendo clic en el botón de arriba"
                            : "Contacta con un administrador para agregar recursos"}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* (**) Modal para nuevo recurso */}
        {mostrarModalNuevo && (
          <div className="historico-seguimiento">
            <div
              className="modal-content"
              style={{ maxWidth: "500px", width: "90vw" }}
            >
              <div
                style={{
                  background: "linear-gradient(135deg, #007932, #005925)",
                  color: "white",
                  padding: "20px",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <h2
                  style={{ margin: 0, fontSize: "1.4rem", fontWeight: "600" }}
                >
                  ➕ Añadir nuevo recurso de empleo
                </h2>
              </div>
              <div style={{ padding: "25px", background: "white" }}>
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    📝 Nombre del recurso *
                  </label>
                  <input
                    type="text"
                    placeholder="Ej: Anuncios del SAE"
                    value={nuevoRecurso.nombre}
                    onChange={(e) =>
                      setNuevoRecurso({
                        ...nuevoRecurso,
                        nombre: e.target.value,
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "border-color 0.2s",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#007932")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  />
                </div>

                <div style={{ marginBottom: "30px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    🔗 URL *
                  </label>
                  <input
                    type="url"
                    placeholder="https://ejemplo.com"
                    value={nuevoRecurso.url}
                    onChange={(e) =>
                      setNuevoRecurso({ ...nuevoRecurso, url: e.target.value })
                    }
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "border-color 0.2s",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#007932")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    onClick={() => setMostrarModalNuevo(false)}
                    style={{
                      padding: "10px 20px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "6px",
                      background: "white",
                      color: "#6b7280",
                      cursor: "pointer",
                      fontWeight: "500",
                      transition: "all 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.borderColor = "#d1d5db")
                    }
                    onMouseOut={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleGuardarRecurso}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "6px",
                      background: "linear-gradient(135deg, #007932, #005925)",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: "500",
                      transition: "all 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.transform = "translateY(-1px)")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.transform = "translateY(0)")
                    }
                  >
                    Añadir recurso
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* (**) Modal de confirmación de borrado */}
        {deleteId && (
          <div className="historico-seguimiento">
            <div
              className="modal-content"
              style={{ maxWidth: "400px", width: "90vw" }}
            >
              <div
                style={{
                  padding: "25px",
                  textAlign: "center",
                  background: "white",
                  borderRadius: "10px",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>⚠️</div>
                <h3 style={{ marginBottom: "15px", color: "#374151" }}>
                  Confirmar eliminación
                </h3>
                <p style={{ marginBottom: "25px", color: "#6b7280" }}>
                  ¿Eliminar el recurso <strong>«{deleteName}»</strong>?<br />
                  Esta acción no se puede deshacer.
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => setDeleteId(null)}
                    style={{
                      padding: "10px 20px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "6px",
                      background: "white",
                      color: "#6b7280",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={borrarRecurso}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "6px",
                      background: "#ef4444",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Listado Ofertas de Empleo con filtros */}
        <section className="empleo-destacado column">
          <h1 className="titulo-user align-center">
            <span className="titulo-user align-center gap-10">
              OFERTAS DE EMPLEO
              <select
                aria-label="Filtradas por"
                className="desplegable-empleo mayusculas"
                value={categoria}
                onChange={(e) => setCategoria(e.target.value)}
              >
                <option value="destacadas">destacadas</option>
                <option value="isla">en Isla Cristina</option>
                <option value="todos">TODAS</option>
              </select>
            </span>
          </h1>
          <Empleos categoria={categoria} />
        </section>
      </main>

      {/* Estilos para la animación de loading */}
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default Empleo;
